import { render, staticRenderFns } from "./TranslatorView.vue?vue&type=template&id=92129aca&scoped=true&"
import script from "./TranslatorView.vue?vue&type=script&lang=js&"
export * from "./TranslatorView.vue?vue&type=script&lang=js&"
import style0 from "./TranslatorView.vue?vue&type=style&index=0&id=92129aca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92129aca",
  null
  
)

export default component.exports